import 'assets/sass/style.scss';
import 'assets/sass/style.react.scss';
import './index.scss';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'antd/dist/antd.css';
import './App.less';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import reportWebVitals from './reportWebVitals';
import { setupJsCommon } from '@internetworkexpert/js-common';
import { bootstrapApp } from './bootstrap';

/* eslint-disable @typescript-eslint/no-var-requires */
const { theme } = require('constants/styles/theme');

const appVersion = '0.90.0';

// Suppress benign ResizeObserver loop errors in development (Chrome)
if (process.env.NODE_ENV !== 'production') {
  const resizeObserverError =
    /ResizeObserver loop (limit exceeded|completed with undelivered notifications)\.?/i;
  window.addEventListener('error', (e) => {
    if (e?.message && resizeObserverError.test(e.message)) {
      e.stopImmediatePropagation();
    }
  });
}

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY,
  releaseStage: process.env.REACT_APP_ENV,
  plugins: [new BugsnagPluginReact()],
  autoDetectErrors: false,
  enabledReleaseStages: ['production', 'staging', 'development'],
  appVersion,
});
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
const ErrorView = () => (
  <div>
    <p>
      Error in the component tree. This may refer to a code error or an unexpected API response.
    </p>
  </div>
);

setupJsCommon(process.env.REACT_APP_ENV || 'production');

const isUnderMaintenance = process.env.REACT_APP_UNDER_MAINTENANCE === 'true';

bootstrapApp({ ErrorBoundary, ErrorView, isUnderMaintenance, theme }).catch(() => {
  try {
    // This only covers unexpected bootstrap failures after its own recovery path. Do not
    // forward an arbitrary error object because it can contain request configuration.
    Bugsnag.notify('Dashboard bootstrap failed unexpectedly');
  } catch (_reportingError) {
    // Nothing else can be rendered safely if React itself failed to mount.
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
